import React from "react";
import useDBO from "../../hooks/useDBO";
import Loading from "../../Loading";
import Error from "../../components/Error";
  
  
  export default function Preparation(props) {
  
    const lessons = useDBO("/preparation")
    if (lessons.loading) return <Loading />
    if (lessons.error) return <Error />

    console.log("Preparation", lessons.get);

    return (<div>
      {lessons.map(lesson=><DrawLesson key={lesson.htClass} lesson={lesson} />)}
      </div>)
};
  
function DrawLesson({ lesson }) {
  return (
    <div className="lesson">
      <h3>{lesson.name}</h3>
      <p>{new Date(lesson.tDate).fDate()}</p>
      <p>{checkMissing(lesson.cLesson)}</p>
      
    </div>
  );
}

function checkMissing(cLesson) {
  if(!cLesson) return "No syllabus"
  return "Missing: " + (cLesson ? cLesson.length : 0) + " lessons";
}